import IconsEnum from '@enums/icons.enum'
import { Media, Tag } from '@hub/shared'
import { useMemo } from 'react'
import './metric-bar.component.scoped.scss'

interface Item {
  icon: string | any
  value: number
  flip?: boolean
  custom?: boolean
}

interface FactoryProps {
  metrics: Item[]
}

interface Props {
  media: Media
}

const FactoryBar = ({ metrics }: FactoryProps) => {
  return (
    <div className="wrapper-factory-bar">
      {metrics?.map((metric, index) => (
        <span style={{ fontSize: '0.9rem' }} key={`metric-${index}`}>
          {metric?.custom ? metric?.icon : null}
          {!metric?.custom ? (
            typeof metric?.icon === 'string' ? (
              <i className={`${metric?.icon}`} style={{ color: 'var(--text_color)', transform: metric?.flip ? 'scaleX(-1)' : null }}></i>
            ) : null
          ) : null}
          {metric?.value || 0}
        </span>
      ))}
    </div>
  )
}

export default ({ media }: Props) => {
  const iconsEnum = useMemo(() => IconsEnum, [])

  const socialNetwork = useMemo(() => media?.origem, [media])

  let instagramBar = (
    <Tag
      labels={
        <div className="metadata-content">
          {media?.tipo.includes('stories') ? (
            <FactoryBar
              metrics={[
                { icon: iconsEnum.reply, value: media?.metadados?.replies || 0 },
                { icon: iconsEnum.tap_back, value: media?.metadados?.taps_back || 0 },
                { icon: iconsEnum.tap_forward, value: media?.metadados?.taps_forward || 0 },
              ]}
            />
          ) : (
            <FactoryBar
              metrics={[
                { icon: iconsEnum.like, value: media?.upvotes || 0 },
                { icon: iconsEnum.comment, value: media?.comentarios || 0 },
                { icon: iconsEnum.save, value: media?.metadados?.saved || 0 },
              ]}
            />
          )}
        </div>
      }
    />
  )

  let youtubeBar = (
    <Tag
      labels={
        <div className="metadata-content">
          <FactoryBar
            metrics={[
              { icon: iconsEnum.videoViewsYt, value: media?.metadados?.views || 0, custom: true },
              { icon: iconsEnum.commentYt, value: media?.comentarios || 0, custom: true },
              { icon: iconsEnum.videoLike, value: media?.upvotes || 0 },
              { icon: iconsEnum.videoDislike, value: media?.metadados?.dislikes || 0 },
              { icon: iconsEnum.reply, value: media?.metadados?.shares || 0 },
            ]}
          />
        </div>
      }
    />
  )

  let twitterBar = (
    <Tag
      labels={
        <div className="metadata-content">
          <FactoryBar
            metrics={[
              { icon: iconsEnum.comment, value: media?.comentarios || 0 },
              { icon: iconsEnum.retweet, value: media?.metadados?.retweets || 0 },
              { icon: iconsEnum.like, value: media?.upvotes || 0 },
            ]}
          />
        </div>
      }
    />
  )

  let tiktokBar = (
    <Tag
      labels={
        <div className="metadata-content">
          <FactoryBar
            metrics={[
              { icon: iconsEnum.like, value: media?.upvotes || 0 },
              { icon: iconsEnum.comment, value: media?.comentarios || 0 },
            ]}
          />
        </div>
      }
    />
  )

  const contentBySocialNetwork = {
    instagram: instagramBar,
    youtube: youtubeBar,
    twitter: twitterBar,
    tiktok: tiktokBar,
  }

  return contentBySocialNetwork[socialNetwork]
}
